export enum MembershipTypeEnum {
    FELLOW = "FELLOW",
    MEMBER = "MEMBER"
}